module.exports = __webpack_public_path__ + "static/media/S (64).ba9d2628.jpg";